//
// LegendTextItems.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/DataVisualization";
import "../data/Role";
import "../core/styles/TextAttributes";

var LegendTextItems = createModule("gtl::LegendTextItems", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization"], EventDispatcher, [
    ,
    {
        textAttributes: 1,
        labelAttributes: 1,
        text: 1,
        label: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LegendTextItems;
